import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { StyledSubCategory } from '../Subcategory/styled';
import { medias } from 'assets/styled/tokens';

export const SubMenuContainer = styled.div`
  width: 100%;
`;
export const StyledCategoryItem = styled.li`
  display: flex;
  justify-content: center;
  width: 100%;
  cursor: pointer;
  background-color: white;
  min-height: 47px;

  ${props =>
    props.isOpen
      ? css`
          ${StyledSubCategory} {
            transform: translateX(88px);
          }
          ${StyledCategoryButton} {
            a {
              div {
                background-color: ${props => (props.disabled ? '#fff' : props.isActive ? '#FCE3C2' : '#f5f3f1')};
              }
            }
            span {
              div {
                background-color: ${props => (props.disabled ? '#fff' : props.isActive ? '#FCE3C2' : '#f5f3f1')};
              }
            }
          }
        `
      : css`
          ${StyledCategoryButton} {
            a {
              div {
                background-color: ${props => (props.isActive ? '#FCE3C2' : '#fff')};
              }
            }
            span {
              div {
                background-color: ${props => (props.isActive ? '#FCE3C2' : '#fff')};
              }
            }
          }
        `}
  @media (min-width: ${medias.desktopXl}) {
    min-height: 55px;
  }
`;

export const IconBox = styled.span`
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: ${props => (props.isActive ? '#FCE3C2' : '#fff')};
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: ${props => (props.disabled ? '#fff' : '#f5f3f1')};
  }
  svg {
    path {
      fill: ${props => (props.disabled ? '#cccccc' : props.isActive ? '#f38a00' : '#AAAAAA')};
    }
  }
`;
export const StyledCategoryButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 10px;
  text-align: center;

  width: 100%;
  padding: 5px;

  a {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: ${props => (props.isChildren ? 'left' : 'center')};
    flex-direction: column;
    gap: ${props => (props.isChildren ? '0' : '4px')};
    font-size: ${props => (props.isChildren ? '12px' : '10px')};
    text-align: left;
    word-wrap: break-word;
    text-decoration: none;
    padding: 0 10px;
    line-height: normal;
    margin-bottom: ${props => (props.isChildren ? '25px' : '0')};

    &:hover {
      color: ${props =>
        props.disabled ? '#cccccc' : props.isActive ? '#FCE3C2' : props.isChildren ? '#f38a00' : '#1E1E1E'};
    }
  }

  a span,
  div span,
  div > * {
    color: ${props =>
      props.disabled ? '#cccccc' : props.isChildren ? '#888888' : props.isActive ? '#f38a00' : '#1E1E1E'};
  }
  svg,
  svg path,
  div svg path,
  a svg path,
  div svg path {
    fill: ${props => {
      return props.disabled ? '#cccccc' : props.isActive ? '#f38a00' : props.isChildren ? '#f38a00' : '#AAAAAA';
    }};
  }
`;

export const StyledNavLink = styled(NavLink)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 4px;
`;
